// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1lsnr","choiceBoxes":"toolbarselects_choiceBoxes__13H86","simpleField":"toolbarselects_simpleField__19hAo"};